// extracted by css-extract-rspack-plugin
export default {"clickThrough":"ouvRh","toastCard":"qjC0l"};